import React from 'react';
import { compose, withHandlers, withPropsOnChange } from 'recompose';
import { reduxForm, Field } from 'redux-form';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { TextField } from 'redux-form-material-ui';
import { get, find } from 'lodash';
import {
  confirmAlternativeReservationItem,
  updateReservationItem,
} from './_api';
import withLoader from '../app/withLoader';
import { Autocomplete } from '../../components/forms/Autocomplete';

const enhance = compose(
  withLoader,
  withHandlers({
    onSubmit: ({
      reservation,
      editDialog,
      setEditDialog,
      loadItem,
      toggleLoader,
    }) => async values => {
      toggleLoader();
      const item = get(values, 'item.value', '');
      const data = {
        reservationItemId: editDialog.reservationItemId,
        userId: reservation.userId,
        requestId: editDialog.requestId,
        alternativeItemId: item.id,
      };

      const [resp1, resp2] = await Promise.all([
        updateReservationItem(editDialog.reservationItemId, {
          price: values.price,
        }),
        confirmAlternativeReservationItem(data),
      ]);
      if (resp1 && resp2) {
        setEditDialog({ open: false });
        await loadItem();
      }
      toggleLoader(false);
    },
  }),
  withPropsOnChange(['editDialog'], ({ editDialog }) => {
    const items = get(editDialog, 'items', []);
    const defaultItemId = get(editDialog, 'defaultItem.items[0].id', null);
    const defaultItem = find(items, { id: defaultItemId });
    return {
      initialValues: { item: defaultItem, price: get(defaultItem, 'price') },
    };
  }),
  reduxForm({ form: 'editItem' })
);

export default enhance(
  ({ editDialog, setEditDialog, fullScreen, handleSubmit, change, item }) => (
    <form onSubmit={handleSubmit}>
      <Dialog
        fullScreen={fullScreen}
        open={editDialog.open}
        onClose={() => setEditDialog({ open: false, title: '' })}
        aria-labelledby="responsive-dialog-title"
        style={{
          minWidth: 400,
          width: '80%',
          minHeight: '80vh',
          maxHeight: '80vh',
        }}
        maxWidth="md"
        fullWidth={true}
      >
        <DialogTitle id="responsive-dialog-title">
          Úprava položky v rezervaci
        </DialogTitle>
        <DialogContent style={{ minHeight: '400px', overflow: 'hidden' }}>
          <Grid container={true} spacing={16}>
            <Grid item={true} xs={6} md={6} lg={6}>
              <Autocomplete
                name="item"
                label={editDialog.title}
                options={get(editDialog, 'items', []).map(item => ({
                  value: item,
                  label: item.label,
                }))}
              />
              {/*<FormControl>
              <InputLabel shrink htmlFor="react-select-single" style={{ width: '150px' }}>
                {editDialog.title}
              </InputLabel>
              <Field
                name={`item`}
                component={props => (
                  <div style={{ top: '16px', position: 'absolute', minWidth: '300px' }}>
                    <Select
                      inputId="react-select-single"
                      value={props.input.value}
                      onChange={props.input.onChange}
                      onBlur={() => props.input.onBlur(props.input.value)}
                      options={get(editDialog, 'items', []).map(item => ({
                        value: item,
                        label: item.label,
                      }))}
                      placeholder="Vybrat"
                      simpleValue
                    />
                  </div>
                )}
              />
                    </FormControl>*/}
            </Grid>
            <Grid item={true} xs={6} md={6} lg={6}>
              <Field
                name="price"
                component={TextField}
                label="Cena"
                fullWidth
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            type="submit"
            color="primary"
            variant="contained"
            onClick={handleSubmit}
            autoFocus
          >
            Uložit
          </Button>
          <Button
            onClick={() => setEditDialog({ open: false, title: '' })}
            color="secondary"
            variant="contained"
          >
            Zrušit
          </Button>
        </DialogActions>
      </Dialog>
    </form>
  )
);



// WEBPACK FOOTER //
// ./src/modules/reservations/editDialog.js